import type { FC } from 'react';
import * as React from 'react';

interface IProps {
  children: React.ReactNode;
}

const LayoutCenter: FC<IProps> = ({ children }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      {children}
    </div>
  );
};

export default LayoutCenter;
